import React, { useEffect, useRef, useState } from "react";
import Register from "./Register";
import { FaMobileScreenButton } from "react-icons/fa6";
import { FiRefreshCcw } from "react-icons/fi";
import { useStoreLogin } from "../../store/login";
import { useStoreLoader } from "../../store/loader";

export default function Otp({ changeScreen , onClose}) {
  const [username, setUsername] = useState("");
  const [showRegister, setShowRegister] = useState(false);
  const [myOtp, setOtp] = useState(new Array(4).fill(""));
  const [screen, setScreen] = useState("USERNAME");
  const otpRefs = useRef([]);
  const isloading = useStoreLoader((state) => state.isloading);
  const [timeLeft, setTimeLeft] = useState(60);
  const timerRef = useRef(null);
  const [otpId, setOtpId] = useState(null);
  const [user, setUser] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [page, setPage] = useState(1);

  let authToken = useStoreLogin.getState().authToken;

  useEffect(() => {
    if (screen === "OTP") startTimer();
    return () => clearInterval(timerRef.current);
  }, [screen]);

  useEffect(() => {
    if (user && authToken) {
      setPage(2);
      onClose && onClose();
    }
  }, [user, authToken]);

  const startTimer = () => {
    setTimeLeft(60);
    timerRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const resetOtp = () => {
    clearInterval(timerRef.current);
    startTimer();
    getOtp();
  };

  const getOtp = async () => {
    try {
      const data = await useStoreLogin.getState().getLoginOtp({ username });
      if (data?.error) {
        setErrorMessage("Mobile number not found. Please check your number.");
      } else {
        setScreen("OTP");
        setOtpId(data?.id || null);
        setUser(data?.user || null);
        setErrorMessage("");
      }
    } catch (error) {
      setErrorMessage("This Mobile Number is not Registered, Try Again.");
    }
  };

  const verifyLoginOtp = async () => {
    try {
      await useStoreLogin.getState().verifyLoginOtp({
        otp: myOtp.join(""),
        id: otpId,
        mobile: username,
        user: user?.id,
      });

      // setPage(2);
    } catch (error) {
      setErrorMessage("OTP verification failed. Please try again.");
    }
  };

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^\d$/.test(value) || value === "") {
      let newOtp = [...myOtp];
      newOtp[index] = value;
      setOtp(newOtp);
    }
  };

  return (
    <section id="loginOtp">
      {!showRegister ? (
        <div className="shadow-md pb-4">
          <div className="font-bold text-base text-center py-4 ">
            <h2 className="text-lg font-bold text-[#052c24]">
              Reg. Mobile no.
              <span className="text-red-500 font-bold">*</span>
            </h2>
          </div>
          {page === 1 ? (
            screen === "USERNAME" ? (
              <div className="flex flex-col items-center px-5">
                <div className="flex items-center border border-[#052c24] rounded-lg px-3 py-2 w-full mb-3 focus-within:ring-2 focus-within:ring-[#FFD338] transition-all">
                  <FaMobileScreenButton className="text-[#052c24] mr-2 text-sm" />
                  <input
                    className="w-full outline-none text-sm bg-transparent placeholder-gray-400"
                    value={username}
                    placeholder="Enter your mobile"
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </div>
                {errorMessage && (
                  <p className="text-red-500 text-sm">{errorMessage}</p>
                )}
                <button className="bg-[#FFD338] hover:bg-[#d6aa08] text-[#052c24] font-semibold px-6 py-2 rounded-lg border border-black shadow-[0px_4px_10px_rgba(0,0,0,0.3)] transition-all text-sm cursor-pointer" onClick={getOtp}>
                  Submit
                </button>
              </div>
            ) : (
              <div className="flex flex-col items-center">
                <p className="font-bold text-lg mb-2 text-[#052c24]">
                  Authenticate Your Account
                </p>
                <p className="text-[#052c24]/70 text-sm">
                  Please enter the code sent to your phone.
                </p>
                <p className="flex items-center gap-2 mb-5 text-sm text-[#052c24]">
                  {username}
                  <FiRefreshCcw
                    className="text-[#FFD338] cursor-pointer hover:text-[#d6aa08]"
                    onClick={() => setScreen("USERNAME")}
                  />
                </p>
                <div className="flex gap-2">
                  {myOtp.map((value, index) => (
                    <input
                      key={index}
                      className="w-12 h-12 text-center border border-[#052c24] rounded-lg outline-none text-lg font-semibold focus:ring-2 focus:ring-[#FFD338] transition-all"
                      value={value}
                      onChange={(e) => handleChange(e, index)}
                      maxLength={1}
                      ref={(input) => (otpRefs.current[index] = input)}
                      onKeyUp={(e) => {
                        if (
                          e.target.value.length === 1 &&
                          index < myOtp.length - 1
                        ) {
                          otpRefs.current[index + 1]?.focus();
                        } else if (e.key === "Backspace" && index > 0) {
                          otpRefs.current[index - 1]?.focus();
                        }
                      }}
                    />
                  ))}
                </div>
                <button
                  className="bg-[#FFD338] hover:bg-[#d6aa08] text-[#052c24] font-semibold px-6 py-2 rounded-lg border border-black shadow-[0px_4px_10px_rgba(0,0,0,0.3)] transition-all text-sm mt-5"
                  onClick={verifyLoginOtp}
                >
                  Submit Code
                </button>
                <button
                  className="bg-white hover:bg-gray-100 text-[#052c24] font-semibold px-6 py-2 rounded-lg border border-gray-300 transition-all text-sm mt-3"
                  onClick={resetOtp}
                  disabled={timeLeft > 0}
                >
                  Resend OTP
                </button>
                {timeLeft > 0 && (
                  <p className="border border-[#052c24] text-[#052c24] rounded-full w-9 h-9 flex items-center justify-center text-sm font-semibold mt-2">
                    {timeLeft}s
                  </p>
                )}
                {errorMessage && (
                  <p className="text-red-500 text-sm mt-2">{errorMessage}</p>
                )}
              </div>
            )
          ) : (
            <div>
              <p className="font-bold text-center pb-[1rem]">
                You have successfully Logged in
              </p>
            </div>
          )}

          <div className="text-center  text-sm lg:text-base pt-2">
            Don&apos;t have an account?{" "}
            <button
              className="text-[#FFD338] hover:text-[#d6aa08] font-semibold underline cursor-pointer"
              onClick={() => changeScreen("REGISTER")}
            >
              Register Now!
            </button>
          </div>
        </div>
      ) : (
        <Register backToLogin={() => setShowRegister(false)} />
      )}
    </section>
  );
}
